import { DefaultService } from '@/services/DefaultService';

export default class AssOcorrenciaCulturaService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

	updateSituacao(ocorrencia, contexto = "agro") {
    return this._http.post(`${this._env}/${contexto}/cultura/ocorrencia/updatesituacao`, ocorrencia, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

	findAll(column, order, page, limit, situacao, id, contexto = "agro", ...params) {
		return this._http.get( encodeURI(`${this._env}/${contexto}/cultura/ocorrencia.json?page=${page}&limit=${limit}&order=${order}&column=${column}&situacao=${situacao}&idcultura=${id}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	findAllCombo(...params) {
		return this._http.get(encodeURI(`${this._env}/agro/cultura/ocorrencia/getcombo.json?param=${params}`), this._headers).then(res => {
      return res.body;
		}, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
		});
	}

	findNaoAssociados(column, order, page, limit, id, contexto = "agro", ...params) {
		return this._http.get( encodeURI(`${this._env}/${contexto}/cultura/ocorrencia/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idcultura=${id}&param=${params}`), this._headers ).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
	}

	find(id) {
		return this._http.get(`${this._env}/agro/cultura/ocorrencia/${id}.json`, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
	}

	save(form, contexto = "agro") {
		return this._http.post(`${this._env}/${contexto}/cultura/ocorrencia`, form, this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw err;
    });
  }

}